import { LIVE_CAMPAIGN_TYPE } from "../constants";

const liveCampaignReducer = (state = {
   page: 1,
   page_size: 10,
   items: []
}, action) => {
   switch (action.type) {
      case LIVE_CAMPAIGN_TYPE.FETCHS:
         return action.payload;
      case LIVE_CAMPAIGN_TYPE.DELETE:
         return {
            ...state,
            items: state.items.filter(f => f.id !== action.payload)
         }
      default:
         return state;
   }
};

export default liveCampaignReducer